export const TopScroll = {
  methods: {
    scrollTopClick() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }
}